import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { DatePicker } from 'antd';
import { getStatTrend } from '../../../http/manager';
import * as echarts from 'echarts';
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import type { DatePickerProps, RangePickerProps } from 'antd/es/date-picker';

const { RangePicker } = DatePicker;

const SystemRecord: React.FC = () => { 
    const [ type, setType ] = useState<number>(1); 
    useEffect(()=> {
        let startTime = dayjs().startOf('month').format('YYYY-MM-DD');
        let endTime = dayjs().endOf('month').format('YYYY-MM-DD');
        getData(startTime, endTime);
        return;
    }, [])
    const getData = (startTime:string, endTime:string)=> {
        let params = {
            startTime: startTime,
            endTime: endTime
        }
        getStatTrend(params).then((res:any)=> {
            let seriesList:any = [];
            res.data.ydata.forEach((element:any)=> {
                let item = {
                    name: element.name,
                    type: 'line',
                    stack: 'Total',
                    smooth: true,
                    label: {
                        show: true,
                        position: 'top'
                    },
                    areaStyle: {},
                    emphasis: {
                        focus: 'series'
                    },
                    data: element.data
                };
                seriesList.push(item);
            })
            let myChart = echarts.init(document.getElementById('systemRecord'));
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    left: '10%',
                    data: res.legnd
                },
                grid: {
                    top: '15%',
                    left: '4%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                color:['rgba(243, 192, 43, .6)','rgba(98, 118, 150, .6)','rgba(95, 217, 168, .6)','rgba(101, 150, 249, .6)'],
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: res.data.xdata
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: seriesList
            })
        })
    }
    const getDate = (
        value: DatePickerProps['value'] | RangePickerProps['value'],
        dateString: [string, string] | string,
      )=> {
        getData(dateString[0], dateString[1]);
    }
    const changeType = (type:number)=> {
        setType(type);
        let startTime, endTime;
        if(type === 1) {
            startTime = dayjs().startOf('month').format('YYYY-MM-DD');
            endTime = dayjs().endOf('month').format('YYYY-MM-DD');
        }else{
            startTime = dayjs().startOf('year').format('YYYY-MM-DD');
            endTime = dayjs().endOf('year').format('YYYY-MM-DD');
        }
        getData(startTime, endTime);
    }
    return (
        <GraphContainer>
            <div className="screenContainer">
                <ul className="tag-list">
                    <li className={ type === 1 ? 'active' : '' } onClick={()=>changeType(1)}>本月</li>
                    <li className={ type === 2 ? 'active' : '' } onClick={()=>changeType(2)}>本年</li>
                </ul>
                <RangePicker className="rangePicker" locale={locale} onChange={getDate}/>
            </div>
            <div id='systemRecord' className="systemRecord"></div>
        </GraphContainer>
    )
}

export default observer(SystemRecord);

const GraphContainer = styled.div`
    & {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .screenContainer {
            position: absolute;
            width: 100%;
            top: -6px;
            right: 3%;
            display: flex;
            justify-content: flex-end;
            z-index: 9;
        }
        ul {
            margin: 0 32px 0 0;
            list-style: none;
            display: flex;
            align-items: center;
            li {
                width: 64px;
                line-height: 32px;
                text-align: center;
                background: #FFFFFF;
                box-shadow: 0px 2px 0px 0px rgba(0,0,0,0.02);
                border-radius: 2px;
                border: 1px solid #D9D9D9;
                font-size: 14px;
                color: rgba(0,0,0,0.85);
                cursor: pointer;
                &.active {
                    background: #4C77FA;
                    box-shadow: 0px 2px 0px 0px rgba(0,0,0,0.04);
                    border-radius: 2px;
                    border: 1px solid #4C77FA;
                    color: #fff;
                }
            }
        }
        .systemRecord {
            width: 100%;
            flex: 1;
        }
    }
`